import React, { FC } from 'react'

import { ProfileState } from 'api/api.constants'
import { ProfileItem } from 'api/search/search.types'
import { ProfileHit } from 'common/constants'
import { SpaceTimeLocationHiddenAbTest } from 'components/block/GeoPermissionRequest/SpaceTimeLocationHiddenAbTest'
import {
  InfoLocation,
  ListItemInfo,
  ListItemPhotoContainer,
  ListItemPhotoSizer,
  ProfileNameStyle,
} from 'components/page/Search/Search.styled'
import { checkIsVerified } from 'components/page/Search/SearchItem/function/checkIsVerified'
import { createCursorPath } from 'components/page/Search/SearchItem/function/createCursorPath'
import { createImageSet } from 'components/page/Search/SearchItem/function/createImageSet'
import { SearchListMismatches } from 'components/page/Search/SearchListMismatches'
import { ProfileLink } from 'components/presentational/ProfileLink/ProfileLink'
import { ProfileName } from 'components/presentational/ProfileName/ProfileName'

import { ItemImageLegacy } from './Part/ItemImageLegacy'

export const ProfileCardLegacy: FC<{ item: ProfileItem }> = ({ item }) => {
  const {
    aid,
    userpic,
    anketaStatuses,
    selfAge,
    isOnline,
    mismatches,
    name,
    cursor,
    gender,
    profile: { state },
  } = item

  const imageSet =
    state === ProfileState.active ? createImageSet(userpic) : undefined
  const isVerified = checkIsVerified(anketaStatuses)
  const cursorString = createCursorPath(cursor)

  return (
    <ProfileLink
      id={aid}
      hit={ProfileHit.SEARCH_HIT}
      data-name={`link-search-profile-action_${aid}`}
      scrollToTop={false}
      additionalPath={cursorString}
    >
      <ListItemPhotoContainer>
        <ListItemPhotoSizer>
          <ItemImageLegacy
            imageSet={imageSet}
            name={name}
            gender={gender}
            userId={aid}
            coordinates={userpic.coords}
          />
        </ListItemPhotoSizer>
      </ListItemPhotoContainer>
      <ListItemInfo>
        <ProfileNameStyle>
          <ProfileName
            fullName={name}
            age={selfAge}
            online={isOnline}
            statusVerification={isVerified}
          />
        </ProfileNameStyle>
        <InfoLocation>
          <SpaceTimeLocationHiddenAbTest
            statuses={anketaStatuses as any}
            gender={gender}
          />
        </InfoLocation>
        <SearchListMismatches mismatches={mismatches} />
      </ListItemInfo>
    </ProfileLink>
  )
}
